/**
 * Constants for Business Units Table
 */

// Mock score generation constants
export const MOCK_SCORE_CONFIG = {
	WEB_FLOW_ANALYZER_BASE_SCORE: 85,
	WEB_SDK_BASE_SCORE: 90,
	MIN_SCORE: 60,
	MAX_SCORE: 100,
	SCORE_VARIATION_RANGE: 20,
	PERCENTAGE_VARIATION_RANGE: 30
} as const;

// Default values
export const DEFAULT_VALUES = {
	SELECTED_PERIOD: 30
};

// Table configuration
export const TABLE_CONFIG = {
	TABLE_ID: 'business-units-table',
	KEY_FIELD: 'id',
	DATA_TYPE: 'Business Unit'
};
